import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]

  connect() {
    // Auto-dismiss after 4 seconds
    setTimeout(() => this.dismissAll(), 4000)
  }

  dismiss(event) {
    event.currentTarget.closest("[data-admin-flash-target='message']")?.remove()
  }

  dismissAll() {
    this.messageTargets.forEach(el => el.remove())
  }
}
